import { FormBase } from 'core/components';

export default class CloseOutPalletizingForm extends FormBase {
	constructor(hooks) {
		super(hooks);
		this.state.options.set({
			validateOnChange: false,
		});
	}
	setup() {
		return {
			fields: [
				{
					name: 'warehouseId',
					label: 'CLOSEOUTPALLETIZINGVIEW.WAREHOUSE',
					rules: 'required',
				},
			],
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/CloseOutPalletizingForm.js